import axios from "@/plugins/axios";

let url = "/api/v1/me/vaccount";

/** @typedef {import("../../../../store/user-vaccounts").UserVaccount} UserVaccount */

export const vaccount = {
    /**
     * @returns {Promise<{ vaccount: UserVaccount }>}
     */
    get() {
        return axios.get(url).then((result) => result.data);
    },

    /**
     * @returns {Promise<{ vaccount: UserVaccount }>}
     */
    delete() {
        return axios.delete(url).then((result) => result.data);
    },

    generate: {
        /**
         * @returns {Promise<{ publicKey: string, vaccount: UserVaccount }>}
         */
        post() {
            return axios.post(`${url}/generate`).then((result) => result.data);
        },
    },

    validate: {
        /**
         * @param {Pick<UserVaccount,'trackId'|'bankCode'|'bankName'|'number'|'holder'>} data
         * @returns {Promise<{ vaccount: UserVaccount }>}
         */
        post(data) {
            return axios.post(`${url}/validate`, data).then((result) => result.data);
        },
    },
};

export default vaccount;
